<template>
  <div class="pb-2">
    <vx-tooltip
      v-if="type == 'icon'"
      text="Nova meta"
      color="primary"
      position="left"
    >
      <feather-icon
        icon="TargetIcon"
        svgClasses="hover:text-success stroke-current mt-1"
        @click="open"
      />
    </vx-tooltip>

    <vs-button v-else @click="open" class="w-full" type="filled">{{
      title
    }}</vs-button>
    <vs-prompt
      :title="title"
      accept-text="Salvar"
      cancel-text="Cancelar"
      button-cancel="border"
      @cancel="cancel"
      @accept="save"
      @close="cancel"
      :is-valid="validateForm"
      :active.sync="activePrompt"
    >
      <div class="modal-size">
        <form class="mx-2">
          <div class="vx-row">
            <div class="vx-col w-full">
              <vs-input
                class="w-full my-2"
                label="Nome *"
                v-model="item.nome"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </div>
            <div class="vx-col w-1/2">
              <vs-input
                class="w-full my-2"
                label="Valor *"
                v-model="item.valor"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </div>
            <div class="vx-col w-1/2">
              <vs-input
                type="date"
                class="w-full my-2"
                label="Prazo *"
                v-model="item.prazo"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Responsável *</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_responsavel"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in usuarios"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Aprovador *</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_aprovador"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in usuarios"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Indicador</span>
              <el-select
                :disabled="disableIndicador"
                class="w-full"
                filterable
                clearable
                v-model="item.id_indicador"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in indicadores"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Setor *</span>
              <el-select
                class="w-full"
                filterable
                clearable
                v-model="item.id_setor"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in setores"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <div class="vx-col w-1/2 mt-2">
              <span class="vs-input--label">Risco</span>
              <el-select
                :disabled="disableRisco"
                class="w-full"
                filterable
                clearable
                v-model="item.id_risco"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="(obj, index) in riscos"
                  :value="obj.id"
                  :label="obj.nome"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <!--div class="vx-col w-full">
              <vs-input
                type="input"
                class="w-full my-2"
                label="Situação"
                v-model="item.obs_geral"
                :color="validateForm ? 'primary' : 'danger'"
              />
            </!--div-->
          </div>
        </form>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
    },
    risco: {
      default() {
        return {};
      },
      required: false,
    },
    indicador: {
      default() {
        return {};
      },
      required: false,
    },
  },
  data() {
    return {
      disableIndicador: false,
      disableRisco: false,
      activePrompt: false,
      item: {},
      usuarios: [],
      indicadores: [],
      riscos: [],
      setores: [],
    };
  },
  computed: {
    validateForm() {
      return (
        this.item.nome != undefined &&
        this.item.nome !== "" &&
        this.item.nome != null &&
        this.item.prazo != undefined &&
        this.item.prazo !== "" &&
        this.item.prazo != null &&
        this.item.valor != undefined &&
        this.item.valor !== "" &&
        this.item.valor != null &&
        this.item.id_responsavel != undefined &&
        this.item.id_responsavel !== "" &&
        this.item.id_responsavel != null &&
        this.item.id_aprovador != undefined &&
        this.item.id_aprovador !== "" &&
        this.item.id_aprovador != null &&
        this.item.id_setor != undefined &&
        this.item.id_setor !== "" &&
        this.item.id_setor != null
      );
    },
  },
  methods: {
    async open() {
      this.activePrompt = true;
      if (this.risco.id > 0) {
        this.disableRisco = true;
        this.item = {
          ...this.item,
          id_risco: this.risco.id,
          nome: `Atender ao risco '${this.risco.nome}'`,
        };
      }
      if (this.indicador.id > 0) {
        this.disableIndicador = true;
        this.item = { ...this.item, id_indicador: this.indicador.id };
      }
      this.item.id_status = 1;
      await this.getData();
    },
    async getData() {
      await this.$vs.loading();
      await Promise.all([
        this.getUsuarios(0),
        this.getIndicadores(0),
        this.getRiscos(0),
        this.getSetores(0),
      ]);

      await this.$vs.loading.close();
    },
    async saveData() {
      await this.$vs.loading();
      try {
        this.rows = await this.$http.post(`${this.url}`, this.item);
        this.$vs.notify(this.$notify.Success);
        await this.cancel();
        this.$emit("done");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        await this.$vs.loading.close();
      }
    },
    async save() {
      if (this.validateForm) {
        await this.saveData();
      }
    },
    async cancel() {
      this.item = {};
    },
    async getUsuarios(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.usuarios = await this.$http.get(`usuario`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getIndicadores(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.indicadores = await this.$http.get(`indicador`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getRiscos(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.riscos = await this.$http.get(`risco`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
    async getSetores(load = true) {
      load ? await this.$vs.loading() : 1;
      try {
        this.setores = await this.$http.get(`setor`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
      } finally {
        load ? await this.$vs.loading.close() : 1;
      }
    },
  },
  async mounted() {},
};
</script>
